export type Environment = 'development' | 'test' | 'production';

export type WebApplication = AppType.Admin | AppType.Dashboard | AppType.Docs;

export enum AppType {
  Admin = 'Admin',
  // 'Bootstrap' is for the very rare situation where we want to make a Postgres
  // request FOR GLOBAL DATA before we've received any particular user request.
  // As of 2026-01-09, this is only used for cache warming.
  Bootstrap = 'Bootstrap',
  Dashboard = 'Dashboard',
  Docs = 'Docs',
  Cron = 'Cron',
  Api = 'Api',
  TemporalWorker = 'TemporalWorker',
  Fixtures = 'Fixtures',
  LocalDebugging = 'LocalDebugging',
  ThirdPartyPubSub = 'ThirdPartyPubSub',
}

export const UNIVERSAL_REQUEST_APP_TYPES = [AppType.TemporalWorker] as const;

export const ORG_REQUEST_APP_TYPES = [AppType.Dashboard, AppType.Api] as const;

export const ADMIN_REQUEST_APP_TYPES = [
  AppType.Admin,
  AppType.LocalDebugging,
] as const;

export const SYSTEM_REQUEST_APP_TYPES = [
  AppType.Bootstrap,
  AppType.Cron,
  AppType.Fixtures,
  AppType.ThirdPartyPubSub,
] as const;

export const API_REQUEST_APP_TYPES = [AppType.Api] as const;

export enum UnauthenticatedAuditableContextType {
  WORKOS_CALLBACK = 'workos_callback',
  OAUTH_SESSION = 'oauth_session',
}

export enum ContentSecurityPolicyFlavor {
  Admin = 'Admin',
  Dashboard = 'Dashboard',
}

// Note: Some of these come from ApolloError, some of these are our own custom
// types.
export enum ErrorCodes {
  CROSS_ORG = 'CROSS_ORG',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  FORBIDDEN = 'FORBIDDEN',
  BAD_USER_INPUT = 'BAD_USER_INPUT',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  FOREIGN_KEY = 'FOREIGN_KEY',
}

// https://www.notion.so/Errors-Error-Handling-Error-Debugging-bebb118d26de4f978070d7075bf22c3b#b940dfd4eb104d66a90e255fe2aba8b3
export enum ErrorKind {
  // Programmer errors are bugs in the program. If our code was perfect and
  // bug-free, we would never have an error of this sort. There is very little
  // that can be done to handle these errors properly, and they should almost
  // always be fixed urgently.
  Programmer = 'Programmer',
  // Operational errors represent run-time problems experienced by correctly
  // written programs. These are not bugs in the program. In fact, these are
  // usually problems with something else: the system itself (e.g., out of
  // memory or too many open files), the system’s configuration (e.g., no
  // route to a remote host), the network (e.g., socket hang-up), or a remote
  // service (e.g., a 500 error, failure to connect, or the like).
  Operational = 'Operational',
  // User input errors are Operational errors caused by a user's choice of
  // input, that we surface to users so they can fix them (think data
  // validation).
  UserInput = 'UserInput',
}

// DuckDB elastic queue names.
export enum ElasticDuckDbQueueName {
  _10Gi = 'duckdb-10gi',
  _54Gi = 'duckdb-54gi',
  _234Gi = 'duckdb-234gi',
  _355Gi = 'duckdb-355gi',
  _719Gi = 'duckdb-719gi',
  _1448Gi = 'duckdb-1448gi',
  Workflow = 'duckdb-wf',
  Development = 'duckdb-dev',
}
